import React from "react";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "sonner";

import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import AnnouncementBanner from "./components/AnnouncementBanner";
import Home from "./pages/Home";
import GalleryPage from "./pages/GalleryPage";
import TestimonialsPage from "./pages/TestimonialsPage";
import CalendarPage from "./pages/CalendarPage";
import AboutPage from "./pages/AboutPage";
import PhilosophyPage from "./pages/PhilosophyPage";
import ProgramsPage from "./pages/ProgramsPage";
import AdmissionsPage from "./pages/AdmissionsPage";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";
import { AuthProvider, useAuth } from "./lib/auth";
import ScrollToTop from "./ScrollToTop";

import "./App.css";

const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center text-brand-blue font-heading">Loading...</div>;
  if (!user) return <Navigate to="/admin/login" replace />;
  return children;
};

const PublicShell = ({ children }) => (
  <>
    <Navbar />
    <AnnouncementBanner />
    {children}
    <Footer />
  </>
);

const Shell = () => {
  const location = useLocation();
  return (
    <Routes>
      <Route path="/" element={<PublicShell><Home /></PublicShell>} />
      <Route path="/about" element={<PublicShell><AboutPage /></PublicShell>} />
      <Route path="/philosophy" element={<PublicShell><PhilosophyPage /></PublicShell>} />
      <Route path="/programs" element={<PublicShell><ProgramsPage /></PublicShell>} />
      <Route path="/admissions" element={<PublicShell><AdmissionsPage /></PublicShell>} />
      <Route path="/gallery" element={<PublicShell><GalleryPage /></PublicShell>} />
      <Route path="/testimonials" element={<PublicShell><TestimonialsPage /></PublicShell>} />
      <Route path="/calendar" element={<PublicShell><CalendarPage /></PublicShell>} />
      <Route path="/admin/login" element={<AdminLogin />} />
      <Route path="/admin" element={<ProtectedRoute><AdminDashboard /></ProtectedRoute>} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
};

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
      <ScrollToTop />
        <Shell />
        <Toaster position="top-right" richColors />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
